import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=2e2f574e"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2f574e')) {
      api.createRecord('2e2f574e', component.options)
    } else {
      api.reload('2e2f574e', component.options)
    }
    module.hot.accept("./AdminDashboard.vue?vue&type=template&id=2e2f574e", function () {
      api.rerender('2e2f574e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminDashboard.vue"
export default component.exports